import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FadeInOutAnimation } from 'src/app/rek-client-app/shared/animations/fade-in-out.animation';
import { DynamicComponent } from 'src/app/shared/modules/dynamic-components/dynamic-component.model';
import { PureHtmlData } from './pure-html-data.model';

@Component({
  selector: 'rek-pure-html',
  templateUrl: './pure-html.component.html',
  styleUrls: ['./pure-html.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeInOutAnimation()]
})
export class PureHtmlComponent implements DynamicComponent {
  @Input() inputData: PureHtmlData;
}
